<!--  -->
<template>
  <div>
    <section class="course-area course-area4">
    <div class="course-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="course-tab-wrap d-flex align-items-center">
                     <img src="/static/images/icon_cuoti.png" class="courses-showing-icon"/><span class="courses-showing-text">共有{{intTotal}}课程</span>
                    </div><!-- end course-tab-wrap -->
                </div><!-- end col-lg-12 -->
            </div><!-- end row -->
            <div class="row courses-search">
                <div class="col-lg-4">
                     <div class="course-filter d-flex align-items-center ml-auto">
                            <div class="courses-ordering">
                                <h3 class="widget__title">课程科目</h3>
                                <el-select v-model="searchType" placeholder="所有科目" @change="toPage(1)">
                                    <el-option
                                    v-for="courcate in courcates"
                                    :key="courcate.name"
                                    :label="courcate.name"
                                    :value="courcate.name">
                                    </el-option>
                                </el-select>
                            </div><!-- end courses-ordering -->
                        </div><!-- end course-filter -->
                </div>
                 <div class="col-lg-4">
                     <div class="sidebar-widget">
                            <h3 class="widget__title">搜索课程</h3>
                            <div class="contact-form-action">
                                <el-input
                                    placeholder="搜索课程"
                                    v-model="searchWords">
                                    <i slot="suffix" class="el-icon-search" @click="toPage(1)"></i>
                                </el-input>
                            </div><!-- end contact-form-action -->
                        </div><!-- end sidebar-widget -->
                </div>
                 <div class="col-lg-4">
                     <div class="sidebar-widget level-widget">
                            <h3 class="widget__title">级别分类</h3>
                            <div class="instructor__list">
                                 <el-radio-group v-model="searchLevel" >
                                    <el-radio label="高级">高级</el-radio>
                                    <el-radio label="中级">中级</el-radio>
                                    <el-radio label="初级">初级</el-radio>
                                </el-radio-group>
                            </div>
                        </div><!-- end sidebar-widget -->
                </div>
            </div>
            <div class="row courses-search">
                <div class="col-lg-4">
                    <div class="sidebar-widget sort-widget">
                        <h3 class="widget__title">排序</h3>
                        <el-select v-model="sortType" placeholder="所有科目">
                            <el-option label="发布时间" value="-createdAt">
                                发布时间
                            </el-option>
                            <el-option label="评分" value="stars">
                                评分
                            </el-option>
                            <el-option label="价格" value="price">
                                价格
                            </el-option>
                            <el-option label="购买人数" value="students">
                                购买人数
                            </el-option>
                        </el-select>
                    </div><!-- end sidebar-widget -->
                </div>
                 <div class="col-lg-4">
                     <div class="sidebar-widget">
                            <h3 class="widget__title">价格</h3>
                            <div class="instructor__list">
                                 <el-radio-group v-model="searchPrice">
                                    <el-radio label="0">免费</el-radio>
                                    <el-radio label="1">收费</el-radio>
                                </el-radio-group>
                            </div>
                        </div><!-- end sidebar-widget -->
                </div>
                 <div class="col-lg-4">
                     <div class="sidebar-widget level-widget">
                            <h3 class="widget__title">讲师</h3>
                             <el-select v-model="searchAuthor" placeholder="所有讲师">
                                <el-option
                                v-for="author in authors"
                                :key="author.title"
                                :label="author.title"
                                :value="author.title">
                                </el-option>
                            </el-select>
                        </div><!-- end sidebar-widget -->
                </div>
            </div>
            <div class="row courses-search">
                <div class="col-lg-12" style="padding-left: 15px;">
                    <div class="sidebar-widget sort-widget">
                        <h3 class="widget__title">评分</h3>
                         <div class="">
                                <el-radio-group v-model="searchStars">
                                <el-radio label="5"><el-rate style="display: inline-block;" :value="5" disabled text-color="#ff9900"></el-rate></el-radio>
                                <el-radio label="4"><el-rate style="display: inline-block;" disabled :value="4"  text-color="#ff9900" ></el-rate></el-radio>
                                <el-radio label="3"><el-rate style="display: inline-block;" :value="3" disabled text-color="#ff9900" ></el-rate></el-radio>
                                <el-radio label="2"><el-rate style="display: inline-block;" :value="2" disabled text-color="#ff9900"></el-rate></el-radio>
                                <el-radio label="1"><el-rate style="display: inline-block;" :value="1"  disabled text-color="#ff9900" ></el-rate></el-radio>
                            </el-radio-group>
                        </div>
                    </div><!-- end sidebar-widget -->
                </div>
            </div>
        </div><!-- end container -->
    </div><!-- end course-wrapper -->
    <div class="course-content-wrapper">
        <div class="container">
            <div class="row course-item-wrap">
                <div class="col-lg-12">
                    <div class="tab-content">
                        <div role="tabpanel" class="tab-pane fade show active" id="tab1">
                            <div class="row course-block">
                                <div class="col-lg-6" v-for="(course,index) in courses" :key="index">
                             <div class="course-item" @click="$router.push(`/courview/info/${course._id}`)">
                                            <div class="course-img">
                                                <router-link :to="`/courview/info/${course._id}`" class="course__img"><img :src="`${global.remoteIp}/uploads/${course.picsrc}`" alt=""></router-link>
                                                <div class="course-tooltip">
                                                    <span v-if="course.spltip" class="tooltip-label">{{course.spltip}}</span>
                                                </div>
                                            </div><!-- end course-img -->
                                            <div class="course-content">
                                                <h3 class="course__title">
                                                    <router-link href="javascript::void(0)" :to="`/courview/info/${course._id}`">{{course.title}}</router-link>
                                                </h3>
                                                <div class="rating-wrap d-flex">
                                                    <span class="course__label-text">{{course.level}}</span>
                                                    <ul class="review-stars d-flex" v-if="course.stars">
                                                        <li><span :class="`la la-star${course.stars==0.5?'-half':course.stars>=1?'':'-o'}`"></span></li>
                                                        <li><span :class="`la la-star${course.stars==1.5?'-half':course.stars>=2?'':'-o'}`"></span></li>
                                                        <li><span :class="`la la-star${course.stars==2.5?'-half':course.stars>=3?'':'-o'}`"></span></li>
                                                        <li><span :class="`la la-star${course.stars==3.5?'-half':course.stars>=4?'':'-o'}`"></span></li>
                                                        <li><span :class="`la la-star${course.stars==4.5?'-half':course.stars>=5?'':'-o'}`"></span></li>
                                                    </ul>
                                                     <ul class="review-stars d-flex" v-else>
                                                        <li><span>暂无评分</span></li>
                                                    </ul>
                                                    <span class="star-rating-wrap" v-if="course.stars">
                                                        <span class="star__rating">{{parseFloat(course.stars).toFixed(1)}}</span>
                                                        <!-- <span class="star__count">({{course.star_count}})</span> -->
                                                    </span>
                                                </div><!-- end rating-wrap -->
                                                <div class="course-meta">
                                                    <ul class="course__list d-flex">
                                                        <li>
                                                            <span class="meta__date">
                                                                <i class="el-icon-video-play"></i> {{course.totalClass}}
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span class="meta__date">
                                                                <i class="el-icon-time"></i> {{course.totalTime}}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div><!-- end course-meta -->
                                                 <p class="course__author">
                                                    <a v-show="course.author">讲师：{{course.author}}</a>
                                                </p>
                                                <!-- <div class="course-price-wrap">
                                                    <div class="course-xstip" v-if="course.befprice">
                                                            <span class="xstip-label">限时特惠</span>
                                                      </div>
                                                     <span class="course__price"><span class="course__before-price" v-if="course.befprice">￥{{course.befprice}}</span>{{`${course.price=='0'?'免费':'￥'+course.price}`}} </span>
                                                      <div class="course-buytip" v-if="course.isBuy">
                                                            <span class="buytip-label">已购买</span>
                                                      </div>
                                                </div> -->
                                            </div>
                                        </div><!-- end course-item -->
                                </div><!-- end col-lg-6 -->
                            </div><!-- end course-block -->
                        </div><!-- end tab-pane -->
                        <div role="tabpanel" class="tab-pane fade" id="tab2">
                            <div class="row course-block course-list-block">
                                <div class="col-lg-12" v-for="(course,index) in courses" :key="index">
                                    <div class="course-item"  @click="$router.push(`/courview/info/${course._id}`)">
                                        <div class="course-img">
                                           <router-link :to="`/courview/info/${course._id}`" class="course__img"><img :src="`${global.remoteIp}/uploads/${course.picsrc}`" alt=""></router-link>
                                        </div><!-- end course-img -->
                                        <div class="course-content">
                                            <p class="course__label">
                                                <span class="course__label-text">{{course.spltip}}</span>
                                                <!-- <a class="course__collection-icon" data-toggle="tooltip" data-placement="top" title="加入愿望单"><span class="la la-heart-o"></span></a> -->
                                            </p>
                                            <h3 class="course__title">
                                              <router-link :to="`/courview/info/${course._id}`">{{course.title}}</router-link>
                                            </h3>
                                            <p class="course__author">
                                                 <a>{{course.author}}</a>
                                            </p>
                                            <div class="rating-wrap d-flex">
                                                    <ul class="review-stars d-flex" v-if="course.stars">
                                                        <li><span :class="`la la-star${course.stars==0.5?'-half':course.stars>=1?'':'-o'}`"></span></li>
                                                        <li><span :class="`la la-star${course.stars==1.5?'-half':course.stars>=2?'':'-o'}`"></span></li>
                                                        <li><span :class="`la la-star${course.stars==2.5?'-half':course.stars>=3?'':'-o'}`"></span></li>
                                                        <li><span :class="`la la-star${course.stars==3.5?'-half':course.stars>=4?'':'-o'}`"></span></li>
                                                        <li><span :class="`la la-star${course.stars==4.5?'-half':course.stars>=5?'':'-o'}`"></span></li>
                                                    </ul>
                                                     <ul class="review-stars d-flex" v-else>
                                                        <li><span>暂无评分</span></li>
                                                    </ul>
                                                    <span class="star-rating-wrap" v-if="course.stars">
                                                        <span class="star__rating">{{parseFloat(course.stars).toFixed(1) }}</span>
                                                    </span>
                                                </div><!-- end rating-wrap -->
                                            <div class="course-meta">
                                                    <ul class="course__list d-flex">
                                                        <li>
                                                            <span class="meta__date">
                                                                <i class="la la-play-circle"></i> {{course.totalClass}}
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span class="meta__date">
                                                                <i class="la la-clock-o"></i> {{course.totalTime}}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div><!-- end course-meta -->
                                                <div class="course-price-wrap">
                                                     <div class="course-xstip" v-if="course.befprice">
                                                            <span class="xstip-label">限时特惠</span>
                                                      </div>
                                                    <span class="course__price"><span class="course__before-price" v-if="course.befprice">￥{{course.befprice}}</span>{{`${course.price=='0'?'免费':'￥'+course.price}`}} </span>
                                                    <div class="course-buytip" v-if="course.isBuy"> 
                                                        <span class="buytip-label">已购买</span>
                                                    </div>
                                                </div><!-- end course-price-wrap -->
                                        </div><!-- end course-content -->
                                    </div><!-- end course-item -->
                                </div><!-- end col-lg-12 -->
                            </div><!-- end course-block -->
                        </div><!-- end tab-pane -->
                    </div><!-- end tab-content -->
                    <div class="pagination-wrap">
                        <nav aria-label="Page navigation">
                            <el-pagination
                            background
                            :page-size="6"
                            :hide-on-single-page="intTotal<=6"
                            layout="prev, pager, next"
                            @current-change="toPage"
                            @prev-click="toPage"
                            @next-click="toPage"
                            :total="intTotal">
                        </el-pagination>
                        </nav>
                    </div><!-- end pagination-wrap -->
                </div><!-- end col-lg-8 -->
            </div><!-- end row -->
        </div><!-- end container -->
    </div><!-- end course-content-wrapper -->
</section><!-- end courses-area -->
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data() {
    return {
      courcates: [],
      courses: [],
      global,
      searchType: "",
      searchWords: "",
      intTotal: 20,
      intCurrent: 1,
      searchAuthor: [],
      plateid: "",
      authors: [],
      searchStars: "",
      searchPrice: [],
      sortType: "",
      searchLevel: [],
    };
  },
  props: {
    plates: Array,
  },
  components: {},

  computed: {},

  mounted() {
    let type = this.$route.query.type;
    let searchConditions = "";
    if(type){
        searchConditions = "&type=" + this.searchType;
    }
     let strextra="";
      if(this.$root.onlymycourse)
      {
        strextra="&type[in]="+ this.$root.hasCourse;
        searchConditions="";
      }
    this.$axios.get("/api/courseTypes?sort=-createdAt").then((res) => {
      if (res.data) {
        this.courcates = res.data.data;
      }
    });
    this.$axios
      .get("/api/courses/visitor?page=1&limit=6&sort=-istop,-createdAt"+searchConditions+strextra)
      .then((res) => {
        if (res.data) {
          this.courses = res.data.data;
          this.intTotal = res.data.total;
        }
      });
    for (var i = 0; i < this.plates.length; i++) {
      if (this.plates[i].name == "名师简介") {
        this.plateid = this.plates[i]._id;
      }
    }
    this.$axios
      .get(`/api/articles?plateid=${this.plateid}&limit=6&sort=-createdAt`)
      .then((res) => {
        if (res.data) {
          this.authors = res.data.data;
        }
      });
  },
  watch: {
    searchAuthor() {
      this.toPage(1);
    },
    searchType() {
      this.toPage(1);
    },
    searchWords() {
      this.toPage(1);
    },
    searchStars() {
      this.toPage(1);
    },
    searchPrice() {
      // this.toPage(1);
    },
    sortType() {
      this.toPage(1);
    },
    searchLevel() {
      this.toPage(1);
    },
  },
  methods: {
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    toPage(intcount) {
      if (intcount) this.intCurrent = intcount;
      var searchConditions = "";
      if (this.searchType) {
        searchConditions += "&type=" + this.searchType;
      }
      if (this.searchWords) {
        searchConditions += "&title=$regex:" + this.searchWords;
      }
      if (this.searchAuthor && this.searchAuthor.length > 0) {
        searchConditions += "&author[in]=" + this.searchAuthor;
      }
      if (this.searchLevel && this.searchLevel.length > 0) {
        searchConditions += "&level[in]=" + this.searchLevel;
      }
      if (this.searchStars) {
        searchConditions += "&stars=" + this.searchStars;
      }
      if (this.sortType) {
        searchConditions += "&sort=" + this.sortType;
      } else {
        searchConditions += "&sort=-istop,-createdAt";
      }
      // if (this.searchPrice == "0") {
      //   searchConditions += "&price=0";
      // } else {
      //   searchConditions += "&price[ne]=0";
      // }
      let strextra="";
      if(this.$root.onlymycourse)
      {
        strextra="&type[in]="+ this.$root.hasCourse;
      }
      this.$axios
        .get(
          `/api/courses/visitor?page=${
            this.intCurrent
          }&limit=6${searchConditions}${strextra}`
        )
        .then((res) => {
          if (res.data) {
            this.intTotal = res.data.total;
            this.courses = res.data.data;
            this.toTop();
          }
        });
    },
  },
};
</script>
<style scoped>
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #51be78;
}
/deep/ .el-pager li.active {
  color: #51be78;
}
/deep/ .el-input__inner{
	height: 61px;
    line-height: 61px;
    width:368.8px;
    margin-top:15px;
    font-size: 16px;
}
/deep/ .el-input__suffix{
     margin-top:15px;
     height: 61px;
   
}
/deep/ .el-select .el-input .el-select__caret{
  color: #4282CAFF;
    font-size: 23px;
    font-weight: 600;
}
.el-icon-search{
        line-height: 61px;
    font-size: 21px;
    margin-right: 10px;
}
/deep/ .el-radio{
    margin-right: 41px;
    margin-left: 27px;
}
/deep/ .el-radio__label{
    font-size:16px;
    /* font-weight: 600; */
}
/deep/ .el-radio__inner{
        border: 2px solid #4485CCFF;
}

.course-wrapper{
	width: 1198px;
	height: 445px;
	background: #ffffff66;
	box-shadow: 0px 6px 17px 1px rgba(68, 133, 204, 0.27);
	border-radius: 5px;
	margin: auto;
	padding: 15px;
}
.course__label-text{
    margin-left: 23px;
}
</style>
